import './external-scripts-loader'
import posthog from './module.no-external.es'
export * from './module.no-external.es'
export default posthog
